module.exports = __webpack_public_path__ + "img/b-hair1.1710effa.png";